var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-group flex flex-row justify-center mx-auto pointer-events-none"},[_c('div',{staticClass:"relative h-full flex flex-row flex-row justify-center text-chplus-s button-row"},[_vm._t("default",function(){return [_c('button',[_vm._v("Button 1")]),_c('button',[_vm._v("Button 2")]),_c('button',[_vm._v("Button 3")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }